// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { BillToModel, CountryModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
import {
    chain,
    ValidateBillingAddress,
    ValidateShippingAddress,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetInitialValues";

type HandlerType = Handler<
    {},
    {
        cart: Cart;
        billTo: BillToModel;
        shipTo?: ShipToModel;
        country?: CountryModel;
    }
>;
/* allow disabling OOTB checkout address validation via site setting */
const isAddressValidationDisabled = (state: ReturnType<Parameters<HandlerType>[0]["getState"]>): boolean => {
    const settings = (getSettingsCollection(state) as any).storeOrderManagementSettingSettings;
    return settings && settings.validateAddressesOnCheckout === false;
};

export const StoreValidateBillingAddress: HandlerType = async props => {
    if (isAddressValidationDisabled(props.getState())) {
        return;
    }
    return ValidateBillingAddress(props);
};

export const StoreValidateShippingAddress: HandlerType = async props => {
    if (isAddressValidationDisabled(props.getState())) {
        return;
    }
    return ValidateShippingAddress(props);
};

replaceInChain(chain, ValidateBillingAddress, StoreValidateBillingAddress);
replaceInChain(chain, ValidateShippingAddress, StoreValidateShippingAddress);

const setInitialValues = createHandlerChainRunnerOptionalParameter(chain, {}, "SetInitialValues");
export default setInitialValues;
